












































































import Vue from "vue";
import { proxyModel } from "@/common/utils/proxyModel";
import { Category } from "../models/Category";
import { Item } from "../models/Item";
import { FixOrderAddItemForm } from "../forms/FixOrderAddItemForm";
export default Vue.extend({
  props: {
    value: {
      type: Object as () => FixOrderAddItemForm
    },
    validations: {
      type: Object
    },
    categories: {
      type: Array as () => Category[]
    },
    items: {
      type: Array as () => Item[]
    }
  },
  computed: {
    ...proxyModel("category", "item", "price", "amount"),
    totalPrice() {
      return (this as any).amount * (this as any).price || 0;
    },
    categoryError() {
      return (this as any).validations.category.$error
        ? "category is required"
        : "";
    },
    itemError() {
      return (this as any).validations.item.$error ? "product is required" : "";
    },
    priceError() {
      return (this as any).validations.price.$error
        ? "price is required or invaild"
        : "";
    },
    amountError() {
      return (this as any).validations.amount.$error
        ? "amount is required or invaild"
        : "";
    }
  },
  methods: {
    selectCategory(category: any) {
      this.$emit("selectCategory", category.id);
    },
    selectProduct(product: any) {
      this.$emit("selectProduct", { amount: 1, price: product.price });
    },
    addItem() {
      this.$emit("addItem");
    },
    nameWithCode(item: Item) {
      return `[${item.code}] ${item.name}`;
    }
  }
});
